export { default as SplitDocuments } from "./Home"